/**
 * When to repaint, and when to actually ask the server.
 *
 * Two different problems that look like one. The clock on screen moving is a
 * local matter: elapsed is a function of `startedAt` and the wall clock, so it
 * can be recomputed every second for nothing. Finding out that the *other*
 * device started or ended a session is a network question, and every one of
 * those is a request somebody pays for.
 *
 * So: repaint every second, poll rarely, and never poll a screen nobody is
 * looking at. At these intervals an open tab costs a few pennies a year.
 */

/** Seconds between server checks while a session is running. */
export const POLL_LIVE_S = 10;

/** Seconds between server checks while nothing is running. */
export const POLL_IDLE_S = 60;

/**
 * Whether this tick is one that should reach the network.
 *
 * `tick` counts seconds since the heartbeat started. Tick zero is never a
 * poll: becoming visible triggers its own immediate refresh, and counting
 * zero as well would double up every time a tab is flipped back to.
 */
export function shouldPoll({ tick, live, visible }) {
  if (!visible || !tick) return false;
  return tick % (live ? POLL_LIVE_S : POLL_IDLE_S) === 0;
}
